import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Valentina M.',
  role: 'Estudiante de Medicina, Buenos Aires',
  age: '22 años',
  text: 'Siempre me costaba Neuroanatomía, pero con los mapas mentales todo hizo clic. Aprobé el final con 9. ¡Increíble!',
  gender: 'female'
}, {
  name: 'Carlos R.',
  role: 'Estudiante de Enfermería, Bogotá',
  age: '24 años',
  text: 'Los esquemas son súper claros. Me ahorraron horas de resumen. Ahora tengo tiempo para repasar tranquilo.',
  gender: 'male'
}, {
  name: 'Lucía F.',
  role: 'Estudiante de Medicina, Lima',
  age: '21 años',
  text: 'La guía simplificada es oro puro. Entendí sistema cardiovascular en una tarde, algo que me llevó semanas intentar sola.',
  gender: 'female'
}, {
  name: 'Diego S.',
  role: 'Estudiante de Kinesiología, Santiago',
  age: '23 años',
  text: 'El método de estudio cambió mi forma de ver la carrera. Ya no me estreso tanto y rindo mucho mejor.',
  gender: 'male'
}, {
  name: 'María José T.',
  role: 'Estudiante de Medicina, Ciudad de México',
  age: '20 años',
  text: 'Lo mejor que compré en la carrera. Los bonos valen más que el precio del producto. 100% recomendado.',
  gender: 'female'
}];
export function TestimonialsSection() {
  return <section className="py-16 bg-gray-50 px-4" data-id="element-186">
      <div className="max-w-6xl mx-auto" data-id="element-187">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-188">
          Lo que dicen otros estudiantes
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-189">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 flex flex-col" data-id="element-190">
              <div className="flex items-center gap-1 mb-4" data-id="element-191">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-192" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-1" data-id="element-193">"{t.text}"</p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-194">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold text-white ${t.gender === 'female' ? 'bg-pink-500' : 'bg-blue-500'}`} data-id="element-195">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-196">
                  <p className="font-bold text-gray-900" data-id="element-197">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-198">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}